import script from "./CreateEditGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateEditGroup.vue?vue&type=script&setup=true&lang=js"

import "./CreateEditGroup.vue?vue&type=style&index=0&id=513dc3c3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-513dc3c3"]])

export default __exports__